import Rest from '../../Rest'

export default class RequestFormIncidentHandlingService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/incident-form'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  updateHandling(id: Number, fields: any) {
    return this.post(`${id}/handling`, fields).then(data => {
      return data
    })
  }

  updateRequestFormIncident(id: Number, formId: Number, dataForm: any) {
    return this.post(`${id}/request_form_incident/${formId}`, dataForm, {
      'Content-Type': 'multipart/form-data;'
    }).then(data => {
      return data
    })
  }

  listHandlingHistory(id: Number) {
    return this.get(`${id}/handling/history`).then(data => {
      return data
    })
  }
}
